import type { FaireProductEntity } from "../../entity_types/product";

export const p_722vusghje: FaireProductEntity = {
  token: "p_722vusghje",
  type: "product",
  name: "PW2151 | Linen Round Neck Short Sleeve Midi Dress",
  brandToken: "b_dr2g2r45g7",
  brandName: "a.ren",
  imageUrl:
    "https://cdn.faire.com/fastly/e9f63f4d2beeaea73f024aac3d80c61606f979bdfbfe4e28efe1d51e927321c7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/edd31e2ed21f954e2c3a0690e85357264d2d7fb303f959d1a7d7f096b6c5a5ab.jpeg",
    "https://cdn.faire.com/fastly/300da046652748932cd4392010d143397afa45bca1307b6357db7dcde582dc15.jpeg",
  ],
  priceDollars: 432,
  description:
    "Woven Cotton Linen Round Neck Short Sleeve Waist Tuck Midi Dress With Back Zipper And Cotton Lining\n\nHand Wash Cold With Like Colors, Do Not Bleach, Hang To Dry, Do Not Iron",
  tags: [],
  msrpDollars: 900,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:20:00.544Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
